import type { PalantirLabelColors } from '../../shared/pipes/labels/labels.type';
import type { PalantirIcon } from '../icon/icon.type';

export interface PalantirSelectItemDialogOptions<T> {
  cancelText: string;
  emptyText: string;
  infiniteScroll?: {
    enabled: boolean;
    loadMore(skip: number, take: number, searchValue: string | null): Promise<T[]>;
    take?: number;
  };
  itemKey?: string;
  items: T[];
  limitItems?: number;
  map(item: T): PalantirSelectItemDialogItem;
  search(value: string | null): Promise<T[]>;
  searchPlaceholderText: string;
  selectAllText: string;
  successText: string;
  title: string;
  type?: PalantirSelectItemDialogType;
}

export interface PalantirSelectItemDialogItem {
  avatar: {
    icon?: PalantirIcon;
    src?: string;
  };
  checked?: boolean;
  children?: PalantirSelectItemDialogItem[];
  disabled?: boolean;
  id: number | string;
  subtitle?: string;
  suffixTag?: PalantirSelectItemDialogItemSuffixTag;
  title: string;
}

export interface PalantirSelectItemDialogItemSuffixTag {
  color: PalantirLabelColors;
  label: string;
  prefix?: PalantirIcon;
  suffix?: PalantirIcon;
}

export enum PalantirSelectItemDialogType {
  multiple = 'multiple',
  single = 'single',
}
